import Utils from "../../utils/Utils";

export default {

    init() {

        const INPUT_AMOUNT = "#input-amount";
        const INPUT_VAT = "#input-vat";
        const INPUT_TAX = "#input-tax";
        const INPUT_TOTAL = "#input-total";

        function getAmount() {
            const amount = $(INPUT_AMOUNT).val();

            if (Utils.isEmpty(amount)) {
                return 0;
            }

            return parseFloat(amount);
        }

        function getVat() {
            const vat = $(INPUT_VAT).val();

            if (Utils.isEmpty(vat)) {
                return 0;
            }

            return parseFloat(vat);
        }

        function setTax(amount, vat) {

            const tax = (amount / 100) * vat;

            $(INPUT_TAX).val(tax);
        }

        function setTotal(amount, vat) {

            const tax = (amount / 100) * vat;

            $(INPUT_TOTAL).val(amount + tax);
        }

        function fillData() {
            const amount = getAmount();
            const vat = getVat();
            setTax(amount, vat);
            setTotal(amount, vat);
        }

        $(INPUT_AMOUNT).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_AMOUNT).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_VAT).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_VAT).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        fillData();
    },

    finalize() {

    }
}
